TachesController.$inject = [
    '$scope',
    '$state',
    '$stateParams',
    '$translate',
    'ModalService',
    'PaginationService',
    'TachesService',
    'notification',
    '$transitions'
];

export default function TachesController(
    $scope,
    $state,
    $stateParams,
    $translate,
    ModalService,
    PaginationService,
    TachesService,
    notification,
    $transitions
) {
    const vm = this;
    const watchers = [];

    let previousTableState;
    vm.selectedTacheId = undefined;
    vm.lastSelected = undefined;

    vm.loading = false;
    vm.params = $stateParams;
    vm.state = $state;
    vm.taches = [];

    vm.slideWidth = '500px';
    vm.slideMargin = {
        'margin-right': '0px',
        'transition-duration': '0.5s',
        'transition-animation': 'margin-right',
        height: '100%'
    };

    vm.itemsByPageOptions = [20, 100, 200];
    vm.itemsByPage = vm.itemsByPageOptions[0];
    vm.getEtats = getEtats;
    vm.getPriorites = getPriorites;

    vm.selectTache = selectTache;
    vm.isTacheSelected = isTacheSelected;
    vm.showDetail = showDetail;
    vm.closeDetail = closeDetail;
    vm.loadTaches = loadTaches;
    vm.deleteTache = deleteTache;
    vm.setSelected = setSelected;
    vm.eraseAllFilters = eraseAllFilters;

    async function init() {
        $transitions.onSuccess({}, stateChangeSuccessFunc);
        watchers.push($scope.$on('$destroy', dispose));
        await getEtats();
        await getPriorites();
        if (shouldSetSelectedId()) {
            vm.setSelected({ id: parseInt($state.params.id) });
        }
    }

    init();

    function stateChangeSuccessFunc(event, toState) {
        if (!$state.params.id) {
            vm.setSelected();
        } else if ($state.params.id) {
            vm.setSelected({ id: parseInt($state.params.id) });
        }
    }

    async function getEtats() {
        vm.etats = await TachesService.getEtats();
    }

    async function getPriorites() {
        vm.priorites = await TachesService.getPriorites();
    }

    function setSelected(tache) {
        if (tache && tache.id) {
            vm.selectedTacheId = $stateParams.id;
            vm.lastSelected = vm.selectedTacheId;
            vm.slideMargin['margin-right'] = vm.slideWidth;
        } else {
            vm.selectedTacheId = undefined;
            vm.slideMargin['margin-right'] = '0px';
        }
    }

    function shouldSetSelectedId() {
        return $state && $state.current && $state.current.name && $state.current.name === 'taches.list.detail' && $stateParams && $stateParams.id;
    }

    function selectTache(tache) {
        if (tache && tache.id) {
            if (vm.selectedTacheId !== tache.id) {
                vm.selectedTacheId = tache.id;
                showDetail(tache.id);
            } else {
                vm.selectedTacheId = undefined;
                closeDetail();
            }
        }
    }

    function isTacheSelected(tache) {
        return tache && tache.id && vm.selectedTacheId === tache.id;
    }

    function showDetail(tacheId) {
        $state.go('taches.list.detail', { id: tacheId });
    }

    function closeDetail() {
        $state.go('taches.list');
    }

    async function loadTaches(tableState) {
        startLoading();

        if ($state && $state.current && $state.current.name !== 'taches.list') {
            $state.go('taches.list');
        }

        if (tableState) {
            previousTableState = tableState;
        }

        const filters = PaginationService.getFilters(previousTableState);
        const sorts = PaginationService.getSorts(previousTableState);
        const pagination = PaginationService.getPagination(previousTableState);

        vm.taches = [];

        try {
            const data = await TachesService.getTaches(filters, sorts, pagination);

            vm.taches = data.items;

            if (previousTableState) {
                PaginationService.setTableState(data.skip, data.take, data.total, previousTableState);
            }
        } catch (ex) {
            notification.error(ex.data);
        } finally {
            stopLoading();
        }
    }

    async function deleteTache(tache) {
        if (tache /*&& tache.canDelete*/ && tache.id) {
            const modalInstance = ModalService.confirm({
                modalTitle: $translate.instant('TACHES.DELETE.TITLE', { libelle: tache.libelle }),
                modalMsg: $translate.instant('TACHES.DELETE.MESSAGE'),
                headerClass: 'modal-danger'
            });

            modalInstance.result.then(async function () {
                startLoading();
                try {
                    await TachesService.deleteTacheById(tache.id);
                    notification.success($translate.instant('TACHES.DELETE.SUCCESS'));

                    vm.selectedTacheId = undefined;

                    if (vm.params.id) {
                        vm.state.go('taches.list');
                    }

                    previousTableState = PaginationService.getTableStateAfterDelete(previousTableState, previousTableState.pagination.take);

                    loadTaches();
                } catch (ex) {
                    notification.error(ex.data);
                } finally {
                    stopLoading();
                }
            });
        }
    }

    function eraseAllFilters() {
        if (previousTableState) {
            previousTableState.search = {};
            previousTableState = PaginationService.getTableStateAfterDelete(previousTableState, previousTableState.pagination.take);
            loadTaches(previousTableState);
        }
    }

    function startLoading() {
        vm.loading = true;
    }

    function stopLoading() {
        vm.loading = false;
    }

    function dispose() {
        watchers.forEach((x) => x());
    }
}
